// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"6fa6eb98","167":"cceea8f6","190":"251686da","208":"4fb9883a"}[chunkId] + ".chunk.css";
};